import React from 'react';
import SocialLinks from './SocialLinks';

const Footer: React.FC = () => (
  <footer className="bg-gradient-to-br from-blush-100 via-sun-50 to-sky-100 py-12">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12">
      <div className="flex flex-col items-center text-center">
        <h3 className="text-2xl font-bold text-ink-800 tracking-tight mb-2">Let's connect</h3>
        <p className="text-ink-600 mb-6 max-w-md">
          Always happy to chat with people building the future of healthcare.
        </p>
        <SocialLinks className="space-x-4 mb-6" />
        <div className="text-ink-500 text-sm">© {new Date().getFullYear()} Sarah Zhou</div>
      </div>
    </div>
  </footer>
);

export default Footer;
